export const SET_RECENT_COLOR = 'set-recent-color'
